<template>
    <section id="home-slide-trust" class="py-4">
        <h1 class="text-center"><b>{{ gettext("Ils nous font confiance") }}</b></h1>
        <div class="logo-slider">
            <div class="logo-track">
                <div class="logo"><a href="https://www.paris-europlace.com/fr" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/paris-europlace.png" /></a></div>
                <div class="logo"><a href="https://www.polylogis.immo/" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/polylogis.jpg" /></a></div>
                <div class="logo"><a href="https://fr.qomon.com/" target="_blank"><img class="big img-fluid" src="/static/img/logo/homepage/qomon.png"/></a></div>
                <div class="logo"><a href="https://www.lapostegroupe.com/fr/actualite/french-iot-le-programme-de-la-poste-qui-accompagne-les-start-up" target="_blank"><img class="standard img-fluid" src="/static/img/FRENCHIOT_LOGO.png" /></a></div>
                <div class="logo"><a href="https://www.afte.com/" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/afte.png" /></a></div>
                <div class="logo"><a href="https://wearesista.com/" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/sista.png" /></a></div>
                <div class="logo"><a href="https://www.keys-reim.com/" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/keys.png" /></a></div>
                <div class="logo"><a href="https://www.famoco.com/fr/" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/FAMOCO.gif" /></a></div>
                <div class="logo"><a href="https://www.paris-europlace.com/fr" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/paris-europlace.png" /></a></div>
                <div class="logo"><a href="https://www.polylogis.immo/" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/polylogis.jpg" /></a></div>
                <div class="logo"><a href="https://fr.qomon.com/" target="_blank"><img class="big img-fluid" src="/static/img/logo/homepage/qomon.png"/></a></div>
                <div class="logo"><a href="https://www.lapostegroupe.com/fr/actualite/french-iot-le-programme-de-la-poste-qui-accompagne-les-start-up" target="_blank"><img class="standard img-fluid" src="/static/img/FRENCHIOT_LOGO.png" /></a></div>
                <div class="logo"><a href="https://www.afte.com/" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/afte.png" /></a></div>
                <div class="logo"><a href="https://wearesista.com/" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/sista.png" /></a></div>
                <div class="logo"><a href="https://www.keys-reim.com/" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/keys.png" /></a></div>
                <div class="logo"><a href="https://www.famoco.com/fr/" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/FAMOCO.gif" /></a></div>
                <div class="logo"><a href="https://www.paris-europlace.com/fr" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/paris-europlace.png" /></a></div>
                <div class="logo"><a href="https://www.polylogis.immo/" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/polylogis.jpg" /></a></div>
                <div class="logo"><a href="https://fr.qomon.com/" target="_blank"><img class="big img-fluid" src="/static/img/logo/homepage/qomon.png"/></a></div>
                <div class="logo"><a href="https://www.lapostegroupe.com/fr/actualite/french-iot-le-programme-de-la-poste-qui-accompagne-les-start-up" target="_blank"><img class="standard img-fluid" src="/static/img/FRENCHIOT_LOGO.png" /></a></div>
                <div class="logo"><a href="https://www.afte.com/" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/afte.png" /></a></div>
                <div class="logo"><a href="https://wearesista.com/" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/sista.png" /></a></div>
                <div class="logo"><a href="https://www.keys-reim.com/" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/keys.png" /></a></div>
                <div class="logo"><a href="https://www.famoco.com/fr/" target="_blank"><img class="standard img-fluid" src="/static/img/logo/homepage/FAMOCO.gif" /></a></div>
            </div>
        </div>
    </section>
</template>

<style scoped lang="scss">
@import "@/assets/vars.scss";
#home-slide-trust {
    padding: 20px 0;
    background-color: white;

    h1 {
        color: $octo-primary;
        padding: 10px 0;
    }
}

$animationSpeed: 20s;

@keyframes scroll {
    0% { transform: translateX(0); }
    100% { transform: translateX(calc(-250px * 8))}
}

.logo-slider {
    background: white;
    height: 100px;
    overflow: hidden;
    position: relative;
    width: 100%;

    &::before,
    &::after {
        content: "";
        height: 100px;
        position: absolute;
        width: 200px;
        z-index: 2;
    }

    &::after {
        right: 0;
        top: 0;
        transform: rotateZ(180deg);
    }

    &::before {
        left: 0;
        top: 0;
    }

    .logo-track {
        animation: scroll $animationSpeed linear infinite;
        display: flex;
        width: calc(250px * 24);
    }

    .logo {
        height: 100px;
        width: 250px;
        display: flex;
        justify-content: space-around;
        align-items: center;

        img {
            max-height: 80px;
            max-width: 160px;
        }
    }
}
</style>
